/*******************************************************************************
 * Project：
 * Summary:
 *　　 SelectCommonComponent
 * Remarks:
 *     Select Common component
 * History：
 *      QuangTN            2021/07/28    Create
 *      NghiaNX            2021/09/18    Add onchange event
 ******************************************************************************/
 import { Component, EventEmitter, Input, OnInit, Output, DoCheck, HostListener, ElementRef } from '@angular/core';
 import * as _ from 'lodash';
 import { LanguageTranslateService } from 'src/app/services/lang-translate.service';
 import { Utility } from '../../utility/utility';
 
 @Component({
   selector: 'app-select-common',
   templateUrl: './select-common.component.html',
   styleUrls: ['./select-common.component.scss']
 })
 export class SelectCommonComponent implements OnInit, DoCheck {
   @Input() lstItem: any[];
   @Input() item: string;
   @Input() class: string;
   @Input() isDisabled: boolean;
   @Input() itemCode: any;
   @Input() placeholder = '';
   @Input() placementPos = '';
   @Input() inpId: string;
   @Output() eventSelectValue = new EventEmitter();
   @Input() isWarning = false;
   lstChange: any;
   showDropDown = false;
   disableBtn = false;
   code: any;
   itemText: string;
   sltWithKey: any = [];
   nextFocus: any;
   fadeLst = false;
   placementTop = false;
   currEle: any;
   constructor(
     public lang: LanguageTranslateService,
     public util: Utility,
     private eRef: ElementRef,
     ) { }
   ngDoCheck(): void {
     if (this.lstItem.length > 0 && !this.util.isNull(this.item)) {
       let idxActive = -1;
       idxActive = this.lstItem.findIndex(e => e.code === this.item);
       // console.log('idxActive:' + idxActive);
       if (idxActive > -1) {
         this.lstItem.map(m => { m.active = false; return m; });
         this.lstItem[idxActive].active = true;
         this.itemText = this.lstItem[idxActive].value;
         this.code = this.lstItem[idxActive].code;
         idxActive = -1;
       }
     } else {
       this.lstItem.map(m => { m.active = false; return m; });
       this.itemText = null;
       this.code = null;
     }
   }
 
   ngOnInit(): void {
     setTimeout(() => {
       this.util.addPerfectScrollBar();
     }, 50);
   }
   togglebutton(event: any) {
     this.showDropDown = !this.showDropDown;
     if (this.showDropDown) {
       this.util.addPerfectScrollBar();
       if (this.placementPos !== ''){
         this.setPos();
       } else{
         this.fadeLst = true;
       }
     } else {
       this.fadeLst = false;
     }
   }
   setPos() {
     setTimeout(() => {
       const rowT = $('.select-common.active').position()?.top;
       const rowH = $('.select-common.active').height();
       const lstH = $('.drop-show.active').height();
       const tbH = $('.' + this.placementPos).height();
       if ((rowT + rowH + lstH) > tbH) {
         this.placementTop = true;
       } else {
         this.placementTop = false;
       }
       setTimeout(() => {
         this.fadeLst = true;
       }, 100);
     }, 150);
   }
   activeSelectFocus(event: any){
     $(event.target).addClass('focused');
     let lstInput;
     let idx = 0;
     this.currEle = event.target as HTMLElement;
     if ($('ngb-modal-window').length > 0) {
       lstInput = $('ngb-modal-window input[type!="checkbox"], ngb-modal-window select, ngb-modal-window textarea, ngb-modal-window div[class="textarea-custom"],  ngb-modal-window .tab-button-focus');
     } else {
       lstInput = $('input[type!="checkbox"], select, textarea, div[class="textarea-custom"], .tab-button-focus');
     }
     const lstInputNotDisabled = [];
     lstInput.each((idx, item) => {
       if (item.getAttribute('disabled') === null && item.getAttribute('readonly') === null) {
         lstInputNotDisabled.push(item);
       }
       if (item.classList.contains('inp-select-focus') && item.getAttribute('disabled') === null ) {
         lstInputNotDisabled.push(item);
       }
     });
     if (lstInputNotDisabled.length > 0) {
       const idxOfCurrEle = lstInputNotDisabled.indexOf(this.currEle);
       // get next element idx
       if (idxOfCurrEle > -1) {
         if (event.shiftKey) {
           idx = idxOfCurrEle === 0 ? lstInputNotDisabled.length - 1 : idxOfCurrEle - 1;
         } else {
           idx = idxOfCurrEle === lstInputNotDisabled.length - 1 ? 0 : idxOfCurrEle + 1;
           this.nextFocus = lstInputNotDisabled[idx];
         }
       } else {
         idx = event.shiftKey ? lstInputNotDisabled.length - 1 : 0;
       }
     }
   }
   selected(it: any) {
     this.lstItem.map(m => m.active = false);
     this.lstItem.map(m => m.focus = false);
     it.active = true;
     it.focus = true;
     this.itemText = it.value;
     this.code = it.code;
     this.outSelectValue(event);
   }
   outSelectValue(event) {
     this.showDropDown = false;
     this.code = this.code === undefined ? null : this.code;
     this.item = this.item === undefined ? null : this.item;
     if (this.code !== this.item) {
       this.item = this.itemText;
       const obj = { value: this.item, code: this.code, inputSelect: this.currEle , nextInput: this.nextFocus};
       this.eventSelectValue.emit(obj);
     }
     if (event.type === 'focusout' || event.type === 'mouseleave') {
       event.preventDefault();
     }
     else {
       this.nextFocus.focus();
     }
     sessionStorage.setItem('isSelectResCode', 'true');
     setTimeout(() => {
       sessionStorage.removeItem('isSelectResCode');
     }, 100);
   }
   onKeyDownEvent(event: any) {
     this.sltWithKey = [];
     if (this.showDropDown === true) {
       const focusKey = event.key.toUpperCase();
       this.sltWithKey = _.filter(this.lstItem, function (it) {
         return it.value.startsWith(focusKey);
       });
     }
     if (event.which === 32) {
       this.togglebutton(event);
     }
     if (event.which === 38 || event.which === 40) {
       let index;
       this.showDropDown = true;
       if (!this.util.isNullOrEmpty(this.item)) {
         index = this.lstItem.findIndex(x => x.focus);
         if (index > -1) {
           this.lstItem[index].focus = true;
         } else if (this.lstItem?.length > 0) {
           this.lstItem[0].focus = true;
         }
       } else if (this.lstItem?.length > 0) {
         this.lstItem[0].focus = true;
       }
     }
     if (this.sltWithKey.length > 0) {
       this.showDropDown = true;
       this.lstItem.map(m => m.focus = false);
       const index = this.lstItem.findIndex(x => x.value === this.sltWithKey[0].value);
       if (index > -1) {
         this.lstItem[index].focus = true;
       }
     }
     setTimeout(() => {
       $('.drop-show.active button.focus').focus();
     }, 200);
   }
   onActionEvent(event: any, it: any) {
     if (event.which === 38 || event.which === 40) {
       const index = this.lstItem.findIndex(x => x.focus === true);
       const max = this.lstItem.length - 1;
       this.lstItem[index].focus = false;
       if (event.which === 38) {
         if (index === 0) {
           this.lstItem[max].focus = true;
         } else {
           this.lstItem[index - 1].focus = true;
         }
       }
       if (event.which === 40) {
         if (index === max) {
           this.lstItem[0].focus = true;
         } else {
           this.lstItem[index + 1].focus = true;
         }
       }
       setTimeout(() => {
         $('.drop-show.active button.focus').focus();
       }, 200);
     }
     const focusKey = event.key.toUpperCase();
     this.sltWithKey = _.filter(this.lstItem, function (it) {
       return it.value.startsWith(focusKey);
     });
     if (this.sltWithKey.length > 0) {
       this.lstItem.map(m => m.focus = false);
       const ind = this.lstItem.findIndex(x => x.value === this.sltWithKey[0].value);
       this.lstItem[ind].focus = true;
       setTimeout(() => {
         $('.drop-show.active button.focus').focus();
       }, 200);
     }
     if (event.which === 9) {
       this.lstItem.map(m => m.focus = false);
       it.focus = true;
       this.outSelectValue(event);
     }
     if (event.which === 32 || event.which === 13) {
       this.lstItem.map(m => m.active = false);
       it.active = true;
       this.itemText = it.value;
       this.code = it.code;
       this.outSelectValue(event);
     }
   }
   @HostListener('document:click', ['$event'])
   clickout(event) {
     if (!this.eRef.nativeElement.contains(event.target)) {
       this.showDropDown = false;
     }
   }
 }
 